<p class="font-13">
  <strong>{{ 'attendance.customFieldAttendance.customFieldsTitle' | translate }}</strong>
</p>
    
<form class="tag-main" [formGroup]="formGroup">
  <div class="d-block w-100 my-3">
    <mat-select 
      class="form-control" 
      formControlName="selectedFields" 
      multiple
      (selectionChange)="addCustomField($event.value)"
      [placeholder]="'attendance.customFieldAttendance.select' | translate"
      #select
    >
      @for (item of listFieldsCustom; track $index) {
        <mat-option [value]="item._id" (click)="select.close()">{{ item.name }}</mat-option>
      }
    </mat-select>  
  </div>
  <div class="d-block w-100" cdkScrollable>
    @for (item of listCustomField; track $index) {
      <div class="form-field-attendance mb-3">
        <div class="form-field-attendance__field">
          <label [for]="item._id" class="form-label">
            {{ item.name.charAt(0).toUpperCase() + item.name.slice(1).toLowerCase() }}:
          </label>

          @switch (getFieldType(item._id)) {
            @case ('TEXT') {
              <input
                type="text"
                class="form-control slide-in-from-top"
                [id]="item._id"
                [formControlName]="item._id"
                [placeholder]="'attendance.customFieldAttendance.enterValueHere' | translate"
              />
            }
            @case ('NUMBER') {
              <input
                type="number"
                class="form-control slide-in-from-top"
                [id]="item._id"
                [formControlName]="item._id"
                [placeholder]="'attendance.customFieldAttendance.enterValueHere' | translate"
              />
            }
            @case ('FREETEXT') {
              <textarea
                class="form-control slide-in-from-top"
                [id]="item._id"
                maxlength="320"
                [formControlName]="item._id"
                [placeholder]="'attendance.customFieldAttendance.enterValueHere' | translate"
              ></textarea>
            }
            @case ('DATE') {
              <div class="trend-datepicker">
                <input 
                  matInput 
                  [matDatepicker]="picker" 
                  placeholder="dd/mm/yyyy" 
                  class="form-control slide-in-from-top" [formControlName]="item._id">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            }
          }
        </div>

        <div class="d-flex align-self-end slide-in-from-top">
          <button 
            class="custom-action-attendance ms-2" 
            [disabled]="!isFieldDirty(item._id)"
            (click)="editCustomField(item._id)"
          >
            <i class="ri-check-line"></i>
          </button>
          <button class="custom-action-attendance" (click)="removeCustomField(item._id)">
            <i class="ri-delete-bin-5-line text-danger"></i>
          </button>
        </div>
      </div>
    }
  </div>
</form>    
  





